export const BASE_URL = process.env.REACT_APP_PLATFORM_BASE_URL
const redirect_URL = "http://localhost:4545/"
export const dateFormat = "YYYY/MM/DD hh:mm:ss"

export function walletImages(name) {
  const baseUrl = process.env.REACT_APP_IMAGE_BASE_URL;

  switch (name) {
    case "KUCOIN":
      return `${baseUrl}/coinlist/kucoin.svg`
    case "COINBASE":
      return `${baseUrl}/coinlist/coinbase_big.svg`
    case "WALLET ADDRESS":
      return `${baseUrl}/coinlist/Bitcoinwallet.png`
  }
}
